import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-bold" }

import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogTrigger,
        DialogBody,
    } from '@/components/ui/dialog';
    import { computed, ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import FileUploadZone from '../FileUploadZone.vue';
    import CreateButton from '@/components/CreateButton.vue';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { Checkbox } from '@/components/ui/form';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';
    import { toast } from 'vue-sonner';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UploadEmployee',
  setup(__props) {

    const open = ref(false);
    const consent = ref(false);
    const uploadedFile = ref([]);

    const page = usePage<SharedData>();
    const selectedCompanyName = computed(() => page.props.auth.user.selected_company_name);
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { t } = useI18n();

    const queryClient = useQueryClient();

    const handleClose = () => {
        uploadedFile.value = [];
        open.value = false;
    };

    const downloadTemplate = () => {
        window.open(route('v2.salary.employees.import-template'), '_blank');
    };

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: open.value,
    "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((open).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(CreateButton, { "button-text": "employee.upload.header" })
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('employee.upload.header')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Checkbox), {
                id: "consent",
                modelValue: consent.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((consent).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_i18n_t, {
                    keypath: "employee.upload.consent",
                    tag: "span",
                    scope: "global"
                  }, {
                    name: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(selectedCompanyName.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (consent.value)
                ? (_openBlock(), _createBlock(FileUploadZone, {
                    key: 0,
                    modelValue: uploadedFile.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((uploadedFile).value = $event)),
                    "accepts-files": ['.xls', '.xlsx'],
                    "instant-upload": "",
                    route: _ctx.route('v2.salary.employees.import'),
                    "max-uploads": 1,
                    onSuccess: _cache[2] || (_cache[2] = () => { _unref(toast).success(_unref(t)('forms.general.success')); _unref(queryClient).invalidateQueries({ queryKey: [_unref(QueryKey).EMPLOYEES, selectedCompanyId.value] }); handleClose(); })
                  }, null, 8, ["modelValue", "route"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                variant: "link",
                width: "narrow",
                size: "sm",
                onClick: downloadTemplate,
                class: "mr-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.download_template')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(DialogClose), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm",
                    onClick: handleClose
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forms.close')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})